import { transformNewsArticleToFeature } from '@/helpers/transforms'
import type { NewsArticleCardBlock } from '@/payload-types'
import type { SerializedBlockNode } from '@payloadcms/richtext-lexical'
import type { JSXConverter } from '@payloadcms/richtext-lexical/react'
import FeatureCardBlock from '../blocks/FeatureCardBlock'

export const NewsArticleCardConverter: JSXConverter<SerializedBlockNode<NewsArticleCardBlock>> = ({
	node,
}) => {
	const card = transformNewsArticleToFeature(node.fields.page)
	return card ? <FeatureCardBlock card={card} /> : null
}
